export class Source {
    sourceId: number;
    description: string;
    langId: number;
    langGroup: number;
    inactive: boolean;
}
